<template>
  <button @click="exportContractData" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportContractData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/client-kyc', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            companyName: item.client ? item.client.companyName : '',
            domain: item.client ? item.client.domain : '',
            type: item.type === 'personal' ? this.$t('personal') : item.type === 'enterprise' ? this.$t('enterprise') : '',
            createTime: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
            createBy: item.createdBy && item.createdBy.name ? item.createdBy.name : '',
            contactName: item.name ? item.name : '',
            address: item.address ? item.address : '',
            taxCode: item.taxCode ? item.taxCode : '',
            confirmTime: item.confirmTime ? moment(item.confirmTime).format('DD/MM/YYYY HH:mm:ss') : '',
            confirmedBy: item.confirmedBy && item.confirmedBy.name ? item.confirmedBy.name : '',
            note: item.note ? item.note : '',
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        })
      } while (response && response.hasNextPage);
      if (!this.cancelRequest) {
        workbook.xlsx.writeBuffer({base64: true}).then(data => {
          this.exporting = false;
          saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              'contract.xlsx');
        }).finally(() => {
          this.cancelRequest = false;
          this.downloadedCount = 0;
        })
      }
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('companyName'), key: 'companyName', width: 20},
        {header: this.$t('domain'), key: 'domain', width: 40},
        {header: this.$t('type'), key: 'type', width: 20},
        {header: this.$t('createTime'), key: 'createTime', width: 20},
        {header: this.$t('createBy'), key: 'createBy', width: 20},
        {header: this.$t('contactName'), key: 'contactName', width: 20},
        {header: this.$t('address'), key: 'address', width: 20},
        {header: this.$t('taxCode'), key: 'taxCode', width: 20},
        {header: this.$t('confirmTime'), key: 'confirmTime', width: 20},
        {header: this.$t('confirmedBy'), key: 'confirmedBy', width: 20},
        {header: this.$t('note'), key: 'note', width: 20},
      ]
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        createBy: 'Create by',
        contactName: 'Contact name',
        address: 'Address',
        taxCode: 'Tax code',
        confirmTime: 'Confirm time',
        confirmedBy: 'Confirmed by',
        personal: 'Personal',
        enterprise: 'Enterprise',
      },
      vi: {
        createBy: 'Tạo bởi',
        contactName: 'Họ tên',
        address: 'Địa chỉ',
        taxCode: 'Mã số thuế',
        confirmTime: 'Xác nhận lúc',
        confirmedBy: 'Xác nhận bởi',
        personal: 'Cá nhân',
        enterprise: 'Doanh nghiệp',
      }
    }
  },
}
</script>